import type { PerformersApi } from 'api-client';
import type { PerformerList } from 'api-client/models';

/** Showbill pickers search the complete shared directory, independently of the team roster. */
export async function loadPerformerDirectory(
  api: PerformersApi,
): Promise<PerformerList[]> {
  const performers: PerformerList[] = [];
  let page = 1;
  while (true) {
    const response = await api.performersList({
      directory: true,
      ordering: 'performer_name',
      page,
    });
    performers.push(...response.results);
    if (!response.next) return performers;
    page += 1;
  }
}
